import React, { useEffect, useRef } from "react";

import { Container } from "./styles";

enum OutsideClickHandlerEvents {
  MOUSEUP = "mouseup",
  MOUSEDOWN = "mousedown",
}

type Props = {
  onClick: () => void;
  children: React.ReactNode;
  onMouseDown?: boolean;
};

const OutsideClickHandler: React.FC<Props> = ({
  onClick,
  children,
  onMouseDown,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const eventType = onMouseDown
      ? OutsideClickHandlerEvents.MOUSEDOWN
      : OutsideClickHandlerEvents.MOUSEUP;

    const handleOutsideClick = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        onClick();
      }
    };

    document.addEventListener(eventType, handleOutsideClick);

    return () => {
      document.removeEventListener(eventType, handleOutsideClick);
    };
  }, [onClick, onMouseDown]);

  return <Container ref={containerRef}>{children}</Container>;
};

export default OutsideClickHandler;
